/**
 * created by wang lei
 xxxxx页面
 *
 */
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import BaseComponent from "../../../../../../../base/BaseComponent";
import {Button} from "antd";

export default class Sta_Button extends BaseComponent {
    static defaultProps = {};
    static propTypes = {};

    constructor(props) {
        super(props);
        this.state = {}
    }

    componentWillMount() {
    }

    componentDidMount() {
    }

    render() {
        const {config,size,onChange,id} = this.props;
        let btnName = config?.btnName || "btnName";
        let type = config?.type || "primary";
        let clickCall = config?.clickCall;
        return (
            <div className={type==='default'?'exportBtn':''}>
                <Button
                    type={type}
                    size={size}
                    id={id}
                    onClick={()=>{
                        if(clickCall && onChange) {
                            onChange({fun:clickCall})
                        }
                    }}
                >{btnName}</Button>
                <style>{`
                   .exportBtn button{
                      color:#000 !important;
                   }
                 `}</style>
            </div>
        )
    }

}